import React from 'react'

import Skeleton from '@client/components/Skeleton'

const TabBuildLoading = () => {
  return (
    <div style={{ padding: 30 }}>
      <Skeleton width={100} />
      <div style={{ display: 'flex', marginTop: 20 }}>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
      </div>
      <div style={{ display: 'flex', marginTop: 20 }}>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
      </div>
      <div style={{ display: 'flex', marginTop: 20 }}>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <Skeleton width={100} />
      </div>
      <div style={{ display: 'flex', marginTop: 20 }}>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
        <div style={{ marginRight: 15 }}>
          <Skeleton width={96} height={90} />
        </div>
      </div>
    </div>
  )
}

export default TabBuildLoading
